<template>
  <v-container fluid>
    <base-material-card
      color="primary"
      icon="mdi-file-table-outline"
      inline
      class="ml-0 px-5 py-4"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Laudo Express
        </div>
      </template>

      <v-btn
        id="btn-nova-montagem-ais-incremental"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left;"
        relative
        text
        medium
        @click="$router.push({ name: 'Montagem AIS Incremental Upload' })"
      >
        <v-icon
          left
          size="30px"
        >
          mdi-plus-circle
        </v-icon>
        Nova Execução
      </v-btn>

      <v-text-field
        id="montagem-ais-incremental-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px;"
      />

      <general-progress-bars
        class="mt-11"
        :items="downloadProgressData"
        prefix-text="Baixando resultado do Laudo Express"
      />

      <v-divider class="mt-10" />

      <v-data-table
        :headers="headers"
        :items="itemsFormatados"
        :search.sync="search"
        :header-props="{ sortByText: 'Ordenar Por' }"
        :footer-props="{ itemsPerPageText: 'Itens por Página' }"
        no-data-text="Nenhum laudo express disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        :loading="loading"
        mobile-breakpoint="900"
      >
        <template v-slot:[`item.titulo`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                class="text-truncate-column clickable-item"
                v-bind="attrs"
                @click="openDialogAcompanhamento(item)"
                v-on="on"
              >
                {{ item.titulo }}
              </div>
            </template>
            <span>{{ item.titulo }}</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.data_base_laudo_formatada`]="{ item }">
          {{ item.data_base_laudo_formatada }}
        </template>

        <template v-slot:[`item.created_formatado`]="{ item }">
          {{ item.created_formatado }}
        </template>

        <template v-slot:[`item.data_processamento_formatado`]="{ item }">
          {{ item.data_processamento_formatado }}
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-montagem-ais-incremental"
            :disabled="!canDownloadResultado(item)"
            :class="!canDownloadResultado(item) ? 'cursor-block' : ''"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="downloadProgressData[item.id] !== undefined"
            @click="downloadResultado(item)"
          >
            <v-icon small>
              mdi-download
            </v-icon>
          </v-btn>

          <v-btn
            id="action-download-errors-montagem-ais-incremental"
            :disabled="!canDownloadRelatorioErros(item)"
            :class="!canDownloadRelatorioErros(item) ? 'cursor-block' : ''"
            min-width="0"
            class="ml-1 px-1"
            fab
            icon
            x-small
            :loading="loadingRelatorioErrosId === item.id"
            @click="downloadRelatorioErros(item)"
          >
            <v-icon small>
              mdi-file-alert-outline
            </v-icon>
          </v-btn>

          <v-btn
            id="action-reprocess-montagem-ais-incremental"
            :disabled="!canReprocess(item)"
            :class="!canReprocess(item) ? 'cursor-block' : ''"
            min-width="0"
            class="ml-1 px-1"
            fab
            icon
            x-small
            @click="reprocessar(item)"
          >
            <v-icon small>
              mdi-play
            </v-icon>
          </v-btn>

          <v-btn
            id="action-details-montagem-ais-incremental"
            color="white"
            class="ml-1"
            height="22px"
            width="22px"
            fab
            x-small
            elevation="1"
            @click="openDialogDetalhes(item)"
          >
            <v-icon small>
              mdi-file-find-outline
            </v-icon>
          </v-btn>
        </template>

        <template v-slot:[`footer`]>
          <v-switch
            v-if="$store.getters.userIsAdmin"
            class="pa-0 pl-2 swithInterna"
            style="position: absolute;"
            color="primary"
            label="Exibir Expirados"
            dense
            @change="$emit('switchProcessamentosExpirados', $event)"
          />
        </template>

        <template v-slot:[`footer.page-text`]>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="$emit('rechargeTable')"
              >
                mdi-refresh
              </v-icon>
            </template>
            <span>Clique aqui para recarregar o histórico</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>

    <general-dialog-detalhes
      title="Detalhes do Laudo Express"
      :show-dialog="dialogDetalhes"
      max-width="1200px"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-progress-linear
          v-if="dialogDetalhesLoading"
          indeterminate
          color="primary"
          class="mb-4"
        />

        <v-data-table
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
          mobile-breakpoint="10"
        />
      </template>
    </general-dialog-detalhes>

    <general-dialog-acompanhamento
      ref="dialogAcompanhamento"
      :show-dialog="dialogAcompanhamento"
      :messages="dialogAcompanhamentoData.andamento"
      :name-event-pusher="'andamento-montagem-ais-incremental-' + dialogAcompanhamentoData.id"
      @changeValue="dialogAcompanhamento = $event"
    >
      <template slot="title">
        Andamento do Laudo Express #{{ dialogAcompanhamentoData.id }}
      </template>
    </general-dialog-acompanhamento>
  </v-container>
</template>

<script>
import dayjs from 'dayjs';
import MontagensAisIncrementaisService from '@/services/MontagensAisIncrementaisService';

export default {
  name: 'MontagensAisIncrementaisTabela',

  components: {
    GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
    GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
    GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes'),
    GeneralDialogAcompanhamento: () => import('@/components/general/GeneralDialogAcompanhamento')
  },

  props: {
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      search: '',
      downloadProgressData: {},
      dialogDetalhes: false,
      dialogDetalhesLoading: false,
      dialogDetalhesData: [],
      dialogAcompanhamento: false,
      dialogAcompanhamentoData: { id: undefined, andamento: [] },
      loadingRelatorioErrosId: null,
      headers: [
        { text: '#', value: 'id' },
        { text: 'Título', value: 'titulo' },
        { text: 'Usuário', value: 'usuario_nome' },
        { text: 'Data Base', value: 'data_base_laudo_formatada' },
        { text: 'Criado em', value: 'created_formatado' },
        { text: 'Processado em', value: 'data_processamento_formatado' },
        { text: 'Status', value: 'status' },
        { text: 'Ações', value: 'actions', sortable: false, class: 'pl-4' }
      ],
      dialogDetalhesHeader: [
        { text: 'Parâmetro', value: 'parametro', sortable: false },
        { text: 'Valor', value: 'valor', sortable: false }
      ]
    };
  },

  computed: {
    itemsFormatados() {
      return this.items.map((item) => ({
        ...item,
        usuario_nome: item.usuario ? item.usuario.nome : '-',
        data_base_laudo_formatada: item.data_base_laudo ? dayjs(item.data_base_laudo).format('DD/MM/YYYY') : '-',
        created_formatado: item.created ? dayjs(item.created).format('DD/MM/YYYY HH:mm') : '-',
        data_processamento_formatado: item.data_processamento ? dayjs(item.data_processamento).format('DD/MM/YYYY HH:mm') : '-'
      }));
    }
  },

  methods: {
    canDownloadResultado(item) {
      return item.status === 'SUCESSO';
    },

    canDownloadRelatorioErros(item) {
      return item.status === 'FALHA' && !!item.arquivo_relatorio_erros;
    },

    canReprocess(item) {
      return item.status !== 'EXECUTANDO' && item.status !== 'AGUARDANDO';
    },

    async downloadResultado(item) {
      if (!this.canDownloadResultado(item)) {
        return;
      }

      const id = item.id;
      this.$set(this.downloadProgressData, id, { id });
      this.$toast.info('Preparando seu arquivo para download.', '', { position: 'topRight', timeout: 2000 });

      try {
        const response = await MontagensAisIncrementaisService.downloadResultado(id, {
          timeout: 60 * 60 * 1000,
          onDownloadProgress: (progressEvent) => this.updateDownloadProgress(id, progressEvent)
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', `laudo_express_${id}.xlsx`);
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.$toast.error(this.getApiErrorMessage(error, 'Falha no download do resultado.'), '', { position: 'topRight' });
        console.error(error);
      } finally {
        this.$delete(this.downloadProgressData, id);
      }
    },

    async downloadRelatorioErros(item) {
      if (!this.canDownloadRelatorioErros(item)) {
        return;
      }

      this.loadingRelatorioErrosId = item.id;

      try {
        const response = await MontagensAisIncrementaisService.baixarRelatorioErros(item.id, {
          timeout: 60 * 60 * 1000
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `erros_laudo_express_${item.id}.xlsx`);
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.$toast.error(this.getApiErrorMessage(error, 'Falha no download do relatório de erros.'), '', { position: 'topRight' });
        console.error(error);
      } finally {
        this.loadingRelatorioErrosId = null;
      }
    },

    async reprocessar(item) {
      if (!this.canReprocess(item)) {
        return;
      }

      try {
        await MontagensAisIncrementaisService.executar(item.id);
        this.$toast.info('Execução reagendada com sucesso.', '', { position: 'topRight', timeout: 2000 });
        this.$emit('rechargeTable');
      } catch (error) {
        this.$toast.error(this.getApiErrorMessage(error, 'Erro ao reagendar a execução.'), '', { position: 'topRight' });
        console.error(error);
      }
    },

    async openDialogDetalhes(item) {
      this.dialogDetalhes = true;
      this.dialogDetalhesLoading = true;
      this.dialogDetalhesData = this.buildResumo(item);

      try {
        const response = await MontagensAisIncrementaisService.getById(item.id);
        const registro = response.data.data;

        this.dialogDetalhesData = this.buildResumo(registro);
      } catch (error) {
        this.$toast.error(this.getApiErrorMessage(error, 'Erro ao carregar detalhes da execução.'), '', { position: 'topRight' });
        console.error(error);
      } finally {
        this.dialogDetalhesLoading = false;
      }
    },

    async openDialogAcompanhamento(item) {
      this.dialogAcompanhamentoData = { id: item.id, andamento: [] };
      this.dialogAcompanhamento = true;

      try {
        const response = await MontagensAisIncrementaisService.andamento(item.id);
        this.dialogAcompanhamentoData.andamento = response.data.andamento || [];
        this.$nextTick(() => {
          if (this.dialogAcompanhamento && this.$refs.dialogAcompanhamento) {
            this.$refs.dialogAcompanhamento.activatePusher();
          }
        });
      } catch (error) {
        const mensagem = this.getApiErrorMessage(error, 'Erro ao carregar andamento da execução.');
        this.dialogAcompanhamentoData.andamento = [mensagem];
        this.$toast.error(mensagem, '', { position: 'topRight' });
        console.error(error);
      }
    },

    buildResumo(item) {
      const resumo = this.parseResumo(item.resumo_json);
      const rows = [
        { parametro: 'ID', valor: item.id || '-' },
        { parametro: 'TÍTULO', valor: item.titulo || '-' },
        { parametro: 'USUÁRIO', valor: item.usuario ? item.usuario.nome : '-' },
        { parametro: 'EXECUTADO POR', valor: item.executado_por_usuario ? item.executado_por_usuario.nome : '-' },
        { parametro: 'ARQUIVO DE UPLOAD', valor: item.arquivo_xlsx ? item.arquivo_xlsx.arquivo : '-' },
        { parametro: 'DATA BASE DO LAUDO', valor: item.data_base_laudo ? dayjs(item.data_base_laudo).format('DD/MM/YYYY') : '-' },
        { parametro: 'VERSÃO DE REFERÊNCIA', valor: item.referencia_versao ? item.referencia_versao.codigo : '-' },
        { parametro: 'CRIADO EM', valor: item.created ? dayjs(item.created).format('DD/MM/YYYY HH:mm') : '-' },
        { parametro: 'PROCESSADO EM', valor: item.data_processamento ? dayjs(item.data_processamento).format('DD/MM/YYYY HH:mm') : '-' },
        { parametro: 'STATUS', valor: item.status || '-' }
      ];

      if (resumo.totais) {
        rows.push(
          { parametro: 'LINHAS PROCESSADAS', valor: resumo.totais.linhas_processadas ?? '-' },
          { parametro: 'LINHAS ELEGÍVEIS', valor: resumo.totais.linhas_elegiveis ?? '-' },
          { parametro: 'TOTAL VOCa', valor: this.formatCurrency(resumo.totais.voca_total) },
          { parametro: 'TOTAL DAC', valor: this.formatCurrency(resumo.totais.dac_total) },
          { parametro: 'TOTAL VMU', valor: this.formatCurrency(resumo.totais.vmu_total) },
          { parametro: 'TOTAL IAD', valor: this.formatCurrency(resumo.totais.iad_total) },
          { parametro: 'TOTAL VBR', valor: this.formatCurrency(resumo.totais.vbr_total) }
        );
      }

      if (Array.isArray(resumo.quadro_resumo) && resumo.quadro_resumo.length) {
        resumo.quadro_resumo.forEach((quadro) => {
          rows.push({
            parametro: `QUADRO ${quadro.cd_q5}`,
            valor: `VOCa ${this.formatCurrency(quadro.voca)} | DAC ${this.formatCurrency(quadro.dac)} | VMU ${this.formatCurrency(quadro.vmu)} | IAD ${this.formatCurrency(quadro.iad)} | VBR ${this.formatCurrency(quadro.vbr)}`
          });
        });
      }

      return rows;
    },

    parseResumo(resumoJson) {
      if (!resumoJson) {
        return {};
      }

      if (typeof resumoJson === 'object') {
        return resumoJson;
      }

      try {
        return JSON.parse(resumoJson);
      } catch (error) {
        return {};
      }
    },

    updateDownloadProgress(id, progressEvent) {
      const progress = progressEvent.total
        ? Math.round((progressEvent.loaded * 100) / progressEvent.total)
        : 0;

      this.$set(this.downloadProgressData, id, {
        id,
        progress,
        isComputable: progressEvent.lengthComputable
      });
    },

    formatCurrency(value) {
      const numero = Number(value || 0);

      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(numero);
    },

    getApiErrorMessage(error, fallback) {
      if (error && error.response && error.response.data && error.response.data.erro) {
        return error.response.data.erro;
      }

      if (error && error.data && error.data.erro) {
        return error.data.erro;
      }

      return fallback;
    }
  }
};
</script>

<style>
.swithInterna label {
  font-size: 13px !important;
  margin-left: 0 !important;
}
</style>
